/* eslint-disable import/prefer-default-export */

import { GET_PERMISSION, GET_COLUMNS, UPDATE_COLUMNS } from '../types';
import network from '../../services/network';
import { callApi } from './utils';

export const getPermission = () => {
  const action = () => network.getPermission();
  return callApi(action, GET_PERMISSION);
};

export const getColumns = () => {
  const action = () =>
    Promise.all([network.getColumnsList(), network.getColumnsPreferences()]);
  return callApi(action, GET_COLUMNS);
};

export const updateColumsList = colums => {
  const action = () => network.updateColumnsList(colums);
  return callApi(action, UPDATE_COLUMNS);
};
